import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || '';

// Tenant slug - resolved on startup
let resolvedTenantSlug = 'default';
let tenantResolved = false;

// Resolve tenant from current domain - fire and forget on load
(function initTenant() {
  const hostname = window.location.hostname;
  axios.get(`${API}/api/tenant/resolve?domain=${encodeURIComponent(hostname)}`)
    .then(res => {
      resolvedTenantSlug = res.data?.slug || 'default';
    })
    .catch(() => {
      resolvedTenantSlug = 'default';
    })
    .finally(() => {
      tenantResolved = true;
    });
})();

function getTenantSlug() {
  return resolvedTenantSlug;
}

const api = axios.create({
  baseURL: `${API}/api`,
});

// Sync interceptor - no async/await
api.interceptors.request.use(config => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.headers['X-Tenant-Slug'] = getTenantSlug();
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('admin_token');
      if (window.location.pathname.startsWith('/admin') && !window.location.pathname.includes('/login')) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(err);
  }
);

export const getFileUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  return `${API}/api/files/${path}`;
};

export { getTenantSlug };
export default api;
